import { addMinutes, addSeconds, differenceInSeconds, format, isAfter, isBefore } from "date-fns";

import { useAppSelector } from "hooks/redux_hooks";
import { useCurrentTime } from "hooks/use_current_time";
import { Settings } from "settings";
import { getClassEndTime, getClassStartTime } from "shared/utils/monitoring";
import { classroomSelectors } from "store";

function padTime(time: number | null) {
  if (time === null) return "--";
  return `${time}`.padStart(2, "0");
}

function CurrentAndElapsedTime() {
  const currentTime = useCurrentTime();

  const classInfo = useAppSelector(classroomSelectors.selectClassInfo());
  const classStartTime = getClassStartTime(classInfo);
  const classEndTime = getClassEndTime(classInfo);
  const classEndTimePlusBuffer = classEndTime && addMinutes(classEndTime, 60);
  const elapsedTimeInSeconds = classStartTime && differenceInSeconds(currentTime, classStartTime);
  const hoursElapsed = elapsedTimeInSeconds && Math.floor(elapsedTimeInSeconds / 3600);
  const minutesElapsed = elapsedTimeInSeconds && Math.floor((elapsedTimeInSeconds % 3600) / 60);
  const secondsElapsed = elapsedTimeInSeconds && Math.floor((elapsedTimeInSeconds % 3600) % 60);

  const showElapsedTime =
    classStartTime &&
    classEndTimePlusBuffer &&
    currentTime > classStartTime &&
    currentTime < classEndTimePlusBuffer;

  const activeTimelineSectionEndTime = useAppSelector(
    classroomSelectors.selectActiveTimelineSectionEndTime(),
  );

  const colorClassName = !activeTimelineSectionEndTime
    ? ""
    : isBefore(currentTime, activeTimelineSectionEndTime)
      ? "text-green"
      : isAfter(
            currentTime,
            addSeconds(activeTimelineSectionEndTime, Settings.FLEX_TIME_FOR_TIMELINE_IN_SECONDS),
          )
        ? "text-red"
        : "text-orange";

  return (
    <div className="flex justify-between pt2 pb1 px2 body-xs bold text-black-tint-70">
      <p className="current-time">{format(currentTime, "h:mmaaa")}</p>
      {showElapsedTime && (
        <p className="elapsed-time-wrapper">
          Elapsed:{" "}
          <span className={`elapsed-time ${colorClassName}`}>{`${padTime(hoursElapsed)}:${padTime(
            minutesElapsed,
          )}:${padTime(secondsElapsed)}`}</span>
        </p>
      )}
    </div>
  );
}

export { CurrentAndElapsedTime };
